import { Helpers } from '../../helpers';
import { IProjectSubType } from '../../interfaces/iproject-sub-type';
import { BudgetCategory } from '../budget-category';
import { Project } from '../project';
import { ProjectTemplate } from '../project-template';
import { ProjectType } from '../project-type';
import { StandardConfigurationProjectSubType } from '../standard-configuration-project-sub-type';

export class ProjectSubTypeBase {
  ProjectSubTypeId: number;
  ProjectTypeId: number | null;
  Description: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  BudgetCategories_ProjectSubType?: Array<BudgetCategory> | null;
  Projects_ProjectSubType?: Array<Project> | null;
  ProjectTemplates_ProjectSubType?: Array<ProjectTemplate> | null;
  StandardConfigurationProjectSubTypes_ProjectSubType?: Array<StandardConfigurationProjectSubType> | null;
  ProjectType?: ProjectType;

  constructor(item?: IProjectSubType) {
    if (item) {

      this.ProjectSubTypeId = item.ProjectSubTypeId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.BudgetCategories_ProjectSubType = Helpers.createClassArray(BudgetCategory, item.BudgetCategories_ProjectSubType);
      this.Projects_ProjectSubType = Helpers.createClassArray(Project, item.Projects_ProjectSubType);
      this.ProjectTemplates_ProjectSubType = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_ProjectSubType);
      this.StandardConfigurationProjectSubTypes_ProjectSubType = Helpers.createClassArray(StandardConfigurationProjectSubType, item.StandardConfigurationProjectSubTypes_ProjectSubType);
      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}